import { WorkerRequest } from "xlcommon/src/pyscript/worker";
import { PyWorker, PyWorkerInfo, getPyWorker as verboseGetPyWorker } from "xlcommon/src/pyscript/pyworker";
import { getValueTypesOfRange, convertDataToTyped, readFromRange } from "xlcommon/src/excel/excel-grid-utils";
import { PyScriptInterpreter } from "xlcommon/src/pyscript/types";

export const INIT_CODE = `import numpy as np
import pandas as pd
from pandas import DataFrame
import matplotlib.pyplot as plt
import seaborn as sns`;

const workerInfo: PyWorkerInfo = {
  worker: undefined,
  terminate: null,
  loadingFlag: false,
  config: {
    pyodideVersion: "0.26.4",
    pyodidePackages: ["numpy", "pandas", "matplotlib", "statsmodels"],
    pyscriptApps: [],
    micropipPackages: ["seaborn==0.13.2"],
    initCode: INIT_CODE,
  },
};

export async function preloadPyWorker() {
  await getPyWorker();
}

export async function getPyWorker() {
  return await verboseGetPyWorker(workerInfo);
}

export async function buildChartPreview(code: string, fullAddress: string): Promise<string> {
  try {
    const py: PyWorker = await getPyWorker();
    const excel_data: any = await readFromRange(fullAddress);
    const valueType = await getValueTypesOfRange(fullAddress);
    const converted = convertDataToTyped(excel_data, valueType, PyScriptInterpreter.pyodide);

    const resp = await py.runCode({
      address: "CHART",
      // Chart preview always uses PyScript, so always uses REF -- no need to check executionLocation or handle xl()
      code: `_data = REF("TABLE")\n\n${code}`,
      mode: 2, // spill + isolated
      data: { TABLE: converted },
    } as WorkerRequest);
    if (resp.error) return resp.error;
    if (resp.result[0][0]?.type === "LocalImage")
      return `<img src="data:image/png;base64,${resp.result[0][0].image.data}">`;
    return `Error: Returned value is not an image -- ${resp.result}`;
  } catch (err) {
    console.log(err);
    return String(err);
  }
}
